'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';

var ChecklistRow = /*#__PURE__*/function (_React$Component) {
  _inherits(ChecklistRow, _React$Component);

  function ChecklistRow() {
    _classCallCheck(this, ChecklistRow);

    return _possibleConstructorReturn(this, _getPrototypeOf(ChecklistRow).apply(this, arguments));
  }

  _createClass(ChecklistRow, [{
    key: "render",
    value: function render() {
      var result = this.props.result;
      var localizedTextKey = result.localizedTextKey;
      return /*#__PURE__*/_jsxs("tr", {
        children: [/*#__PURE__*/_jsx("td", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: localizedTextKey + ".header"
          })
        }), /*#__PURE__*/_jsxs("td", {
          children: [result.displayValue, /*#__PURE__*/_jsx("span", {
            children: result.displayValueUnit
          })]
        }), /*#__PURE__*/_jsxs("td", {
          children: [result.displayRecommendationValue, /*#__PURE__*/_jsx("span", {
            children: result.displayRecommendationValueUnit
          })]
        }), /*#__PURE__*/_jsx("td", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: localizedTextKey + ".result.recommendation"
          })
        })]
      });
    }
  }]);

  return ChecklistRow;
}(React.Component);

export { ChecklistRow as default };